import { styled, Text, View } from "tamagui";

const StatCardBody = styled(View, {
  name: "StatCardBody",
  variants: {
    variant: {
      default: {
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "$gray-50",
        gap: "$1",
        minHeight: 160,
      },
    },

    state: {
      success: {
        color: "$success-500",
      },
      warning: {
        color: "$warning-500",
      },
      neutral: {
        color: "$gray-600",
      },
      danger: {
        color: "$error-500",
      },
    },
    size: {
      lg: {
        paddingVertical: "$4.2",
        paddingHorizontal: "$4",
      },
      md: {
        paddingVertical: "$2.3",
        paddingHorizontal: "$4",
      },
    },
    rounded: {
      lg: {
        borderRadius: "$5",
      },
    },
  } as const,
  defaultVariants: {
    variant: "default",
    state: "neutral",
    size: "lg",
    rounded: "lg",
  },
});

const StatScore = styled(Text, {
  name: "StatScore",
  fontFamily: "$subtitle",
  fontWeight: "$4",
  fontSize: "$7",
  lineHeight: "$7",
  textAlign: "center",
  color: "inherit",
});

const StatDescription = styled(Text, {
  name: "StatDescription",
  fontFamily: "$subtitle",
  lineHeight: "$2",
  fontWeight: "$5",
  fontSize: "$2",
  textAlign: "center",
});

export const StatCard = {
  Body: StatCardBody,
  Score: StatScore,
  Description: StatDescription,
};
